const archive = document.querySelector('body.post-type-archive-uttalelser');

if(archive) {
  let selectedCaseType = new URLSearchParams(document.location.search).get('case_type') || '';
  let selectedSubCaseType = new URLSearchParams(document.location.search).get('sub_case_type') || '';
  let selectedYear = new URLSearchParams(document.location.search).get('period') || '';
  let customFrom = new URLSearchParams(document.location.search).get('from') || '';
  let customTo = new URLSearchParams(document.location.search).get('to') || '';
  let currentPage = parseInt(new URLSearchParams(document.location.search).get('page')) || 1;

  // Custom date range, revealed by the "Egendefinert" option in the period dropdown
  const customPeriod = archive.querySelector('.custom-period');
  const customPeriodOption = archive.querySelector('.filter-group.period .select-options a[data-value="custom"]');
  const fromInput = customPeriod.querySelector('#period-from');
  const toInput = customPeriod.querySelector('#period-to');
  const applyPeriodBtn = customPeriod.querySelector('.apply-period');

  // SEARCH
  const searchForm = archive.querySelector('.filter-form');
  const inputField = searchForm.querySelector('input');
  const submitBtn = searchForm.querySelector('button');

  searchForm.addEventListener('submit', function(e) {
    e.preventDefault();
    e.stopPropagation();
  });

  inputField.addEventListener('search', function(e) {
    updatePage();
  });

  submitBtn.addEventListener('click', function(e) {
    e.preventDefault();
    updatePage();
  });

  if(archive.querySelector('.filter-group.period .select-options li a.selected')) {
    archive.querySelector('.filter-group.period .active-input span').innerHTML = archive.querySelector('.filter-group.period .select-options li a.selected').getAttribute('data-name');
  }

  if(archive.querySelector('.filter-group.case_type .select-options li a.selected')) {
    archive.querySelector('.filter-group.case_type .active-input span').innerHTML = archive.querySelector('.filter-group.case_type .select-options li a.selected').getAttribute('data-name');
  }

  // FILTER
  const caseTypeSelect = archive.querySelector('.filter-group.case_type .active-input');
  caseTypeSelect.addEventListener('click', function(e) {
    e.preventDefault();
    if(!this.classList.contains('open')) {
      $(this.closest('.select-input').querySelector('.select-options')).slideDown(500);
      this.querySelector('button').setAttribute('aria-expanded', 'true');
      this.classList.add('open');
      if(window.innerWidth >= 768) {
        document.querySelector('body').classList.add('no-scroll');
        $('html, body').animate({
          scrollTop: $(this).offset().top - 100
        }, 300);
      }
    }
    else {
      $(this.closest('.select-input').querySelector('.select-options')).slideUp(500);
      this.classList.remove('open');
      this.querySelector('button').setAttribute('aria-expanded', 'false');
      document.querySelector('body').classList.remove('no-scroll');
    }
  });

  const caseTypeOptions = archive.querySelectorAll('.filter-group.case_type .select-options li a');
  caseTypeOptions.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      selectedCaseType = this.getAttribute('data-value');
      selectedSubCaseType = '';
      updatePage();
    });
  });

  const yearSelect = archive.querySelector('.filter-group.period .active-input');
  yearSelect.addEventListener('click', function(e) {
    e.preventDefault();
    if(!this.classList.contains('open')) {
      $(this.closest('.select-input').querySelector('.select-options')).slideDown(500);
      this.classList.add('open');
      this.querySelector('button').setAttribute('aria-expanded', 'true');
      if(window.innerWidth >= 768) {
        document.querySelector('body').classList.add('no-scroll');
        $('html, body').animate({
          scrollTop: $(this).offset().top - 100
        }, 300);
      }
    }
    else {
      $(this.closest('.select-input').querySelector('.select-options')).slideUp(500);
      this.classList.remove('open');
      this.querySelector('button').setAttribute('aria-expanded', 'false');
      document.querySelector('body').classList.remove('no-scroll');
    }
  });

  const yearOptions = archive.querySelectorAll('.filter-group.period .select-options li a');
  yearOptions.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      // "Egendefinert" opens the date fields instead of filtering straight away
      if(this.getAttribute('data-value') === 'custom') {
        closeSelect(yearSelect);
        customPeriod.hidden = false;
        this.setAttribute('aria-expanded', 'true');
        fromInput.focus();
        return;
      }

      customFrom = '';
      customTo = '';
      selectedYear = this.getAttribute('data-value');
      updatePage();
    });
  });

  applyPeriodBtn.addEventListener('click', function(e) {
    e.preventDefault();

    // An empty range would filter nothing, so leave the current period alone
    if(!fromInput.value && !toInput.value) {
      return;
    }

    customFrom = fromInput.value;
    customTo = toInput.value;
    selectedYear = 'custom';
    updatePage();
  });

  function closeSelect(activeInput) {
    if(!activeInput.classList.contains('open')) {
      return;
    }
    $(activeInput.closest('.select-input').querySelector('.select-options')).slideUp(500);
    activeInput.classList.remove('open');
    activeInput.querySelector('button').setAttribute('aria-expanded', 'false');
    document.querySelector('body').classList.remove('no-scroll');
  }

  function closeCustomPeriod() {
    customPeriod.hidden = true;
    customPeriodOption.setAttribute('aria-expanded', 'false');
  }

  function filterParams() {
    const params = new URLSearchParams();
    params.set('page', currentPage);
    params.set('sok', inputField.value.toLowerCase());
    params.set('case_type', selectedCaseType);
    params.set('sub_case_type', selectedSubCaseType);
    params.set('period', selectedYear);

    if(selectedYear === 'custom') {
      params.set('from', customFrom);
      params.set('to', customTo);
    }

    return params;
  }

  function updatePage() {
    currentPage = 1;
    window.location.href = window.location.pathname + '?' + filterParams().toString();
  }


  function getCount() {
    let data = new FormData();
    data.append('action', 'get_statements_count');
    data.append('sok', inputField.value.toLowerCase());
    data.append('case_type', selectedCaseType);
    data.append('sub_case_type', selectedSubCaseType);
    data.append('period', selectedYear);
    data.append('from', customFrom);
    data.append('to', customTo);

    $.ajax({
        url: sivilombudet_scripts.ajax_url,
        type: 'POST',
        data: data,
        cache: false,
        processData: false,
        contentType: false,
        dataType: 'json',
        error: function (data) {
            console.error(data);
        },
        success: function (response) {
             archive.querySelectorAll('.filter-group.period .select-options li a').forEach(function(option, index) {
              if(index < 1) {
               return; 
              }
              let type = option.getAttribute('data-type');
              if (type && response[type] != undefined) {
                 option.querySelector('.count').innerHTML = response[type];
              }
              else if(type && response.hasOwnProperty(type)) {
                option.querySelector('.count').innerHTML = '0';
              }
            });
            archive.querySelectorAll('.filter-group.case_type .select-options li a').forEach(function(option, index) {
              if(index < 1) {
               return; 
              }
              let type = option.getAttribute('data-slug');
              if (type && response[type] != undefined) {
                 option.querySelector('.count').innerHTML = response[type];
              }
              else if(type && response.hasOwnProperty(type)) {
                option.querySelector('.count').innerHTML = '0';
              }
            });
            archive.querySelectorAll('.sub-case-types ul li a').forEach(function(link, index) {
              let type = link.getAttribute('data-slug');
              if (type && response[type] != undefined) {
                 link.querySelector('.count').innerHTML = response[type] ;
              }
              else if(type && response.hasOwnProperty(type)) {
                link.querySelector('.count').innerHTML = '0';
              }
            });
        }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      getCount();
    }, 200);
  });

  window.addEventListener('click', function(e) {
    if (!e.target.closest('.active-input')) {
      archive.querySelectorAll('.active-input').forEach(function(openSelect) {
        if(openSelect.classList.contains('open')) {
          $(openSelect.closest('.select-input').querySelector('.select-options')).slideUp(500);
          openSelect.classList.remove('open');
          openSelect.querySelector('button').setAttribute('aria-expanded', 'false');
        }
      });
      document.querySelector('body').classList.remove('no-scroll');
    }

    // "Egendefinert" is what opens the panel, so a click on it must not close it again
    if (!e.target.closest('.custom-period') && !e.target.closest('a[data-value="custom"]')) {
      closeCustomPeriod();
    }
  });

}